import React ,{ useEffect, useRef, useState } 
from "react";
import { FormProvider, useForm } from "react-hook-form";

import { IFilterNotice, getDefaultFilterNotice } from "../../../models/interfaces/IFilterNotice";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { validationMode } from "../../../config/helpers";
import CpntMultiSelect from "../../../components/CpntMultiSelect";
import { useFetchCompteGetAllMarquesQuery } from "../../../redux/slice/api/FO/compteApi";
import { useKeycloak } from "@react-keycloak/web";
import { yupResolver } from "@hookform/resolvers/yup";
import { NoticesFilterSchema } from "../../../models/schema/NoticesFilterSchema";
import CpntFilterButtons from "../../../components/CpntFilterButtons";


interface IProps {
  filter?: IFilterNotice;
  changeFilter: (data: IFilterNotice) => void;
}


//Arrive pas a faire passer unb param au parent...
const NoticesFilter: React.FC<IProps> = ({ filter, changeFilter }) => {
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const prevFilterRef = useRef<IFilterNotice | undefined>(filter);
  const [selectedIds, setSelectedIds] = useState<any[]>([]);
  const { data: marques } = useFetchCompteGetAllMarquesQuery(undefined, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated 
  });
  useEffect(() => {
    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }
    prevFilterRef.current = filter;
  }, [filter]);

  
  const formMethods = useForm<IFilterNotice>({
    defaultValues: getDefaultFilterNotice(),
    mode:"all",
    resolver: yupResolver(NoticesFilterSchema),
  });

  const { handleSubmit, reset,getValues } = formMethods;
 

  const onSubmit = (data: IFilterNotice) => {
    const idsOnly = selectedIds.map((option: { value: any }) => option.value);
    const combinedData: IFilterNotice = {
      ...data,
      SocieteIds: idsOnly,
    };
    changeFilter(combinedData);
    localStorage.setItem("IFilterNotices",JSON.stringify(combinedData)); //need ??
  };

  
  useEffect(() => {
    if (filter?.SocieteIds) {
      const selectedValues = marques?.Marques?.filter((marque: { Id: any }) =>
        filter?.SocieteIds?.includes(marque.Id)
      ) || [];

      // Create an object from selectedValues to map to options
      const selectedValuesList = selectedValues?.map((marque: { Libelle: any; Id: any }) => {
        return {
          label: marque.Libelle,
          value: marque.Id,
        };
      });
      setSelectedIds(selectedValuesList);
    }
  }, [marques]);
  


  const handleResetForm = () => {
    localStorage.removeItem("IFilterNotices");
    localStorage.removeItem("NoticesNavigator");
    changeFilter(getDefaultFilterNotice());
    setSelectedIds([]);
    reset(getDefaultFilterNotice()); // Réinitialise explicitement le formulaire
  };


  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };


  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      //e.preventDefault();// Empêche le comportement par défaut, comme la soumission du formulaire
      handleSubmit(onSubmit)();
    }
  };
  
  const mappedOptions = marques?.Marques || [];
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntFormSection pSectionLabel="Recherche notice">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6,6,6, 6, 6, 6, 12]}>
          <CpntMultiSelect 
            DefaultLibelle="Sélectionner..."
            options={mappedOptions}
            value={selectedIds}
            setSelected={setSelectedIds}
            label="Sélectionner une marque"
            ></CpntMultiSelect>
            <div></div>
            <TextInput
              label="Titre"
              formName="Titre"
              validationStyle={validationMode.none}
              placeholder="Titre"
            />
            <TextInput
              label="EAN / ISBN"
              formName="EanIsbn"
              validationStyle={validationMode.none}
              placeholder="EAN / ISBN"
            />
             <TextInput
              label="Auteur"
              formName="Auteur"
              validationStyle={validationMode.none}
              placeholder="Auteur"
            />
             <TextInput
              label="Collection"
              formName="Collection"
              validationStyle={validationMode.none}
              placeholder="Collection"
            />
            <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
      </form>
    </FormProvider>
  );
};

export default NoticesFilter;
